import * as React from 'react';

import { InlineNotification } from '@coursera/cds-core';

import _t from 'i18n!nls/degree-home';

export const RestoreSuccessNotification: React.FunctionComponent<{
  onDismiss: () => void;
}> = ({ onDismiss }) => {
  return (
    <InlineNotification
      severity="success"
      title={_t('This item has been restored to your main calendar')}
      onDismiss={onDismiss}
      children=""
    />
  );
};
